var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.2,67.1l-42.7-42.7c-4.2-4.2-10.9-4.2-15.1,0c-4.2,4.2-4.2,10.9,0,15.1l35.1,35.1l-35.1,35.1 c-2,2-3.1,4.7-3.1,7.5v32c0,23.5,19.1,42.7,42.7,42.7v181.3c0,5.9-4.8,10.7-10.7,10.7c-5.9,0-10.7-4.8-10.7-10.7V352 c0-17.6-14.4-32-32-32H384V42.7C384,19.1,364.9,0,341.3,0H128c-23.5,0-42.7,19.1-42.7,42.7v384c-23.5,0-42.7,19.1-42.7,42.7v32 c0,5.9,4.8,10.7,10.7,10.7H416c5.9,0,10.7-4.8,10.7-10.7v-32c0-23.5-19.1-42.7-42.7-42.7v-85.3h10.7c5.9,0,10.7,4.8,10.7,10.7 v21.3c0,17.6,14.4,32,32,32s32-14.4,32-32V74.7C469.3,71.8,468.2,69.1,466.2,67.1z M106.7,42.7c0-11.8,9.6-21.3,21.3-21.3h213.3 c11.8,0,21.3,9.6,21.3,21.3v384h-256L106.7,42.7L106.7,42.7z M405.3,469.3v21.3H64v-21.3c0-11.8,9.6-21.3,21.3-21.3H384 C395.8,448,405.3,457.6,405.3,469.3z M448,170.7c-11.8,0-21.3-9.6-21.3-21.3v-27.6l21.3-21.3V170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.7,42.7h-192c-5.9,0-10.7,4.8-10.7,10.7v128.2c0,5.9,4.8,10.7,10.7,10.7h192c5.9,0,10.7-4.8,10.7-10.7 V53.3C341.3,47.4,336.6,42.7,330.7,42.7z M320,170.9H149.3V64H320V170.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.eeeebf94c067dd8d9d548ae66b141ad2.svg";
export { ForwardRef as ReactComponent };